<template>
	<div
		v-tippy="'Es handelt sich hierbei um ein Log für ein internes Projekt'"
		class="bg-secondary rounded-full w-2 h-2 inline-block ml-3 mb-0.5 cursor-help"
	/>
</template>
